//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/assets/scss/pages.scss'
import { mapState } from 'vuex'
import headMixin from '~/mixins/head.mixin'

export default {
  layout: 'contacts',
  mixins: [headMixin],
  computed: {
    ...mapState(['i18n']),
  },
  head() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    return {
      title: this.$getTextSetting(
        'title',
        this.$i18n.locale === 'ru' ? 'Контакты' : 'Contacts'
      ),
      htmlAttrs: {
        ...i18nHead.htmlAttrs,
        dir: this.$direction(),
      },
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$getTextSetting(
            'description',
            this.$i18n.locale === 'ru'
              ? 'Контакты Алгоритмики'
              : 'Algorithmic`s contact'
          ),
        },
      ],
    }
  },
}
